import styled from "styled-components";
// import { Link } from "react-router-dom";

export const Wrapper = styled.section`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 20px;
	padding: 50px 120px 0 120px;
	flex-direction: row;
	flex-wrap: wrap;
	background-color: #f4f4f4;

	h1 {
		flex-basis: 100%;
		text-align: center;
		margin-top: 0;
		padding-bottom: 60px;
		color: var(--darkGrey);
	}

	@media screen and (max-width: 720px) {
		margin: 0;
		padding: 20px 20px 20px 20px;
		flex-direction: column;
		gap: 30px;

		h1 {
			padding-bottom: 30px;
		}
	}
`;
export const Content = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	text-align: center;
	position: relative;

	p {
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		width: 100%;
		height: 100%;
		border-radius: 100px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: var(--white);
		font-size: var(--fontMed);
		background-color: ${({ styleOnScroll }) =>
			styleOnScroll ? "rgba(31, 31, 31, 0.9)" : ""};

		-webkit-animation: cssAnimation 3s forwards;
		animation: cssAnimation 3s forwards;

		@keyframes cssAnimation {
			0% {
				opacity: 1;
			}
			90% {
				opacity: 1;
			}
			100% {
				opacity: 0;
			}
		}
		@-webkit-keyframes cssAnimation {
			0% {
				opacity: 1;
			}
			90% {
				opacity: 1;
			}
			100% {
				opacity: 0;
			}
		}
	}
`;
export const MenuImage = styled.img`
	width: 150px;
	height: 150px;
	object-fit: cover;
	border-radius: 1000px;
	transition: outline 0.2s linear;
	outline: solid 0 rgba(31, 31, 31, 0.9);
	text-decoration: none;

	:hover {
		outline: solid 4px rgba(31, 31, 31, 0.9);
		text-decoration: none;
		/* outline-width: 6px; */
	}
`;
